// Converte string com virgula ("66,10") ou numero para float. Vazio/invalido -> 0.
export function n(v) {
  if (v === null || v === undefined || v === '') return 0
  const parsed = parseFloat(String(v).replace(',', '.'))
  return isNaN(parsed) ? 0 : parsed
}

export function fatWeight (totalWeight, fatPercentage) {
  return ((n(totalWeight) * n(fatPercentage)) / 100).toFixed(2)
}

export function skinnyWeight(totalWeight, fatWeight) {
  return (n(totalWeight) - n(fatWeight)).toFixed(2)
}

export function sumSkinfolds(subScapular, triceps, biceps, chest, midAxillary, supraIliac, abdomen, thigh, leg) {
  leg = 0
  biceps = 0
  let sumSkinfolds = n(subScapular) + n(triceps) + n(biceps) + n(chest) + n(midAxillary) + n(supraIliac) + n(abdomen) + n(thigh) + n(leg)
  return sumSkinfolds.toFixed(2)
}

export function percentageBodyFatPollock(age, sumSkinfolds) {
  age = n(age)
  sumSkinfolds = n(sumSkinfolds)
  if(age == 0 || sumSkinfolds == 0) return 0
  let dc = 1.112 - 0.00043499 * sumSkinfolds + 0.00000055 * sumSkinfolds * 2 - 0.00028826 * age
  let bf = (495/dc) - 450
  return bf.toFixed(2)
}

/*
export function pollockCalc(age, subScapular, triceps, biceps, chest, midAxillary, supraIliac, abdomen, thigh, leg) {
  let sumPollock = subScapular + triceps + biceps + chest + midAxillary + supraIliac + abdomen + thigh + leg
  let dc = 1.112 - 0.00043499 * sumPollock + 0.00000055 * sumPollock * 2 - 0.00028826 * age
  let bf = (495/dc) - 450
  return bf.toFixed(2)
}*/

// Mifflin-St Jeor (altura chega em metros -> converte p/ cm)
// Homens:   TMB = (10 x peso) + (6,25 x altura_cm) - (5 x idade) + 5
// Mulheres: TMB = (10 x peso) + (6,25 x altura_cm) - (5 x idade) - 161
export function basalMetabolicRate(weight, height, age, gender) {
  weight = n(weight); height = n(height); age = n(age)
  if(weight == 0 || height == 0 || age == 0) return 0
  const heightCm = height * 100
  const base = (10 * weight) + (6.25 * heightCm) - (5 * age)
  const tmb = gender == 'M' ? base + 5 : base - 161
  return tmb.toFixed(2)
}

// Mesma formula de Mifflin, porem usando o PESO MAGRO no lugar do peso corporal
export function mmMetabolicRate(skinnyWeight, height, age, gender) {
  skinnyWeight = n(skinnyWeight); height = n(height); age = n(age)
  if(skinnyWeight == 0 || height == 0 || age == 0) return 0
  const heightCm = height * 100
  const base = (10 * skinnyWeight) + (6.25 * heightCm) - (5 * age)
  const tmb = gender == 'M' ? base + 5 : base - 161
  return tmb.toFixed(2)
}

export function imc(weight, height) {
  weight = n(weight); height = n(height)
  if(weight == 0 || height == 0) return 0
  let result = weight / (height * height)
  if(isNaN(result)) return 0
  return result.toFixed(2)
}

// Risco cardiaco = Relacao Cintura/Quadril (RCQ). Cintura e quadril vem da aba Circunferencia.
// Classificacao (tabela WHR): BAIXO / MODERADO / ALTO / MUITO ALTO por sexo.
export function waistHipRatio(waist, hip) {
  const w = n(waist)
  const h = n(hip)
  if(w == 0 || h == 0) return 0
  return (w / h).toFixed(2)
}

// Tabela RCQ - Applied Body Composition Assessment (Human Kinetics, 1996), por idade e sexo.
// Cada faixa etaria: [baixoMax, altoMin, muitoAltoMin]
//   ratio <  baixoMax     -> BAIXO
//   ratio <  altoMin      -> MODERADO
//   ratio <= muitoAltoMin -> ALTO
//   ratio >  muitoAltoMin -> MUITO ALTO
const WHR_TABLE = {
  M: [
    { maxAge: 29, t: [0.83, 0.89, 0.94] },
    { maxAge: 39, t: [0.84, 0.92, 0.96] },
    { maxAge: 49, t: [0.88, 0.96, 1.00] },
    { maxAge: 59, t: [0.90, 0.97, 1.02] },
    { maxAge: 200, t: [0.91, 0.99, 1.03] },
  ],
  F: [
    { maxAge: 29, t: [0.71, 0.78, 0.82] },
    { maxAge: 39, t: [0.72, 0.79, 0.84] },
    { maxAge: 49, t: [0.73, 0.80, 0.87] },
    { maxAge: 59, t: [0.74, 0.82, 0.88] },
    { maxAge: 200, t: [0.76, 0.84, 0.90] },
  ],
}

export function cardiacRisk(waist, hip, gender, age) {
  const ratio = parseFloat(waistHipRatio(waist, hip))
  if(!ratio) return { value: 0, classification: '-' }

  const rows = WHR_TABLE[gender == 'M' ? 'M' : 'F']
  const idade = parseInt(age) || 0
  const row = rows.find((r) => idade <= r.maxAge) || rows[rows.length - 1]
  const [baixoMax, altoMin, muitoAltoMin] = row.t

  let classification
  if(ratio < baixoMax) classification = 'BAIXO'
  else if(ratio < altoMin) classification = 'MODERADO'
  else if(ratio <= muitoAltoMin) classification = 'ALTO'
  else classification = 'MUITO ALTO'

  return { value: ratio.toFixed(2), classification }
}